import { computed, action } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { ICardConfiguration } from '../models';
import { ICardProps } from '@kurtosys/ksys-app-components/dist/components/base/Card/models';

export class CardStore extends StoreBase {
	static componentKey: 'card' = 'card';

	@computed
	get configuration(): ICardConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration(CardStore.componentKey);
		}
	}

	@computed
	get props(): ICardProps | undefined {
		const appCardProps = this.storeContext.appStore && this.storeContext.appStore.appCardProps;
		const props = this.mergeQueriesAndProps<ICardProps | undefined>(this.configuration) || appCardProps;
		if (props) {
			const { appStore } = this.storeContext;
			if (appStore && appStore.splitAppOptions) {
				const { hideCardHeader } = appStore.splitAppOptions;
				if (hideCardHeader) {
					props.title = undefined;
					props.subtitle = undefined;
				}
			}
		}
		return props;
	}

	@action
	async initialize(): Promise<void> {

	}
}